import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Button, Row, Alert } from "reactstrap";
import Select from "react-select";
import i18n from "../../../i18n";
import { delServicesCancelAdmin, delServicesCancelReservAdmin } from "../../../helpers/api_rombo_helper";
import { cancellationReasons } from "../../../constants/utils";
import { TypeService } from "../../../constants/enums";

const RequestServiceCancelModal = ({ isOpen, toggle, setRequestServiceCancelModal, setShowAlertSuccess, selectedService, setSelectedService, setTextHeader, setTextBody, token, typeService, setReloadList, reloadList }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [cancelReason, setCancelReason] = useState(null);

  function onClickSave() {
    const body = {
      codes: [selectedService.code],
      canceled_info: {
        reason: cancelReason?.label,
      },
    };

    switch (typeService) {
      case TypeService.RESERVATIONS:
      case TypeService.ASSIGNMENT:
        delServicesReserv(body);
        break;
      case TypeService.REQUEST:
        delServices(body);
        break;
      default:
        console.error("Unrecognized service type:", typeService);
    }
  }

  function delServices(body) {
    delServicesCancelAdmin(token, body)
      .then(() => handleSuccess())
      .catch((error) => handleError(error));
  }

  function delServicesReserv(body) {
    delServicesCancelReservAdmin(token, body)
      .then(() => handleSuccess())
      .catch((error) => handleError(error));
  }

  function handleSuccess() {
    setRequestServiceCancelModal(false);
    setShowAlertSuccess(true);
    setSelectedService({});
    setReloadList(!reloadList);
    setTextHeader(i18n.t("CancelledService"));
    setTextBody(i18n.t("SuccessCanceledService", { number: 1 }));
  }

  function handleError(error) {
    console.error("Error:", error);
    if (error.response?.status === 409) {
      setErrorAlertMessage(i18n.t("PickUpError"));
    } else {
      setErrorAlertMessage(error.response?.data?.detail || error.message || i18n.t("ServerError"));
    }
    setErrorAlert(true);
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop="static"
      id="staticBackdrop"
      size="lg"
    >
      <div>
        <p className="cancellation-title modal-header-bottom">{i18n.t("CancelRequest")}</p>
        <div className="modal-separator" />
        <p className="cancellation-subtitle">{i18n.t("SelectCancellationReason")}</p>
        <ModalBody className="mt-0 pt-0">
          <div id="liveAlertPlaceholder">
            <Alert
              color="danger"
              isOpen={errorAlert}
              toggle={() => setErrorAlert(false)}
            >
              {errorAlertMessage}
            </Alert>
          </div>
          <Row>
            <p className="cancellation-text">{selectedService.code}</p>
          </Row>
          <Row>
            <h6 className="cancellation-reason">{i18n.t("CancellationReason")}</h6>
            <Select
              value={cancelReason}
              onChange={(selectedOption) => setCancelReason(selectedOption)}
              options={cancellationReasons}
              placeholder={i18n.t("SelectACancellationReason")}
              isClearable
              classNamePrefix="cancelattion-select"
              className="select2-selection"
            />
            <p className="cancellation-text">{i18n.t("TextCancelService")}</p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={onClickSave}
            disabled={!cancelReason}
          >
            {i18n.t("Accept")}
          </Button>
          <Button className="btn-light" type="button" onClick={toggle}>
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

RequestServiceCancelModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setRequestServiceCancelModal: PropTypes.func.isRequired,
  setShowAlertSuccess: PropTypes.func.isRequired,
  setTextHeader: PropTypes.func.isRequired,
  setTextBody: PropTypes.func.isRequired,
  selectedService: PropTypes.object.isRequired,
  token: PropTypes.object.isRequired,
  setSelectedService: PropTypes.func.isRequired,
  typeService: PropTypes.string.isRequired,
  setReloadList: PropTypes.func.isRequired,
  reloadList: PropTypes.bool.isRequired,
};

export default RequestServiceCancelModal;
